import type { ImageBlockProps } from "./types";

export type { ImageBlockProps };

/**
 * ImageBlock component
 * @param props - ImageBlockProps
 * @description Found in src/components/blocks/image-block/index.tsx
 */
export function ImageBlock(props: ImageBlockProps) {
	const format = {
    undefined: "aspect-auto",
    "66:25": "aspect-[66/25]",
    "16:9": "aspect-video",
    "4:3": "aspect-[4/3]",
    "1:1": "aspect-square",
  };
	const classNames = `${format[props.format]} object-cover bg-gray-200`;
	const altText =
		props.imageAltText ??
		props.imageCaption ??
		(props.photographer ? `Foto: ${props.photographer}` : undefined);

	return (
    <figure className="flex flex-col gap-[7px] mb-6 md:gap-2 md:mb-7 xl:gap-[9px] xl:mb-8">
      <img src={props.imageUrl} className={classNames} alt={altText} />
      {(props.imageCaption || props.photographer) &&
        (props.imageCaption ? (
          <figcaption>
            {props.imageCaption}
            {props.photographer && (
              <>
                {" Foto: "}
                {props.photographer}
              </>
            )}
          </figcaption>
        ) : (
          <figcaption>Foto: {props.photographer}</figcaption>
        ))}
    </figure>
  );
} 